const accountRoot = 'account';
const adminRoot = 'admin';
const authenticationRoot = 'authentication';
const dashboardRoot = 'dashboard';
const servicesRoot = 'services';
const shareRoot = 'r';

const AppSettings = {
  ApplicationName: 'Nectarine',
  PrivacyPolicyUrl: 'https://s3.amazonaws.com/files.hellonectarine.com/SC8aOavKzk6B2I4Mzd8yvw-nectarine-privacy-policy.pdf',
  NectarineADV2A: 'https://s3.amazonaws.com/files.hellonectarine.com/7jXr8nRu0Ot7MGI28ldg-nectarine-adv-part-2a.pdf',
  NectarineCRS: 'https://s3.amazonaws.com/files.hellonectarine.com/MsArmVi5IkGYOOVyN8jYzQ-nectarine-form-crs.pdf',
  ThePlanWelcomePDF: 'https://s3.us-east-1.amazonaws.com/files.hellonectarine.com/Nectarine+Financial+Plan+Welcome.pdf',
  TypeFormBaseUrl: process.env.REACT_APP_TYPEFORM_BASE_URL || '404',
  WebsiteRoot: process.env.REACT_APP_WEBSITE_ROOT,
  WebsiteEnvironment: process.env.REACT_APP_WEBSITE_ENVIRONMENT as 'development' | 'staging' | 'production'
};

const AttributeCategories = {
  ICanHelpYouWith: 1,
  IEnjoyWorkingWith: 2
};

const AttributeCategoriesText = {
  ICanHelpYouWith: 'I Can Help You With',
  IEnjoyWorkingWith: 'I Enjoy Working With'
};

// Features that exist in code but are not visible to all users yet
const FeatureFlags = {
  SpringEasterEggs: 'SpringEasterEggs',
  WinterEasterEggs: 'WinterEasterEggs',
  ThePlanWelcomeEmail: 'ThePlanWelcomeEmail',
  TheOngoing: 'TheOngoing',
  AdvisorRecommendations: 'AdvisorRecommendations',
  NetWorthTracking: 'NetWorthTracking'
};

const RecordingStatus = {
  Processing: 'Processing',
  SavedToS3: 'SavedToS3',
  SavedToS3AndDeletedFromZoom: 'SavedToS3AndDeletedFromZoom',
  DeletedByUser: 'DeletedByUser',
  Error: 'Error'
};

const LocalStorageKeys = {
  Advisor: {
    MeetingNotes: 'meetingNotes'
  },
  General: {
    ReturnUrl: 'returnUrl',
    LastUrls: 'lastUrls'
  }
};

const UserLoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register'
};

const UserLogoutActions = {
  LogoutCallback: 'logout-callback',
  Logout: 'logout',
  LoggedOut: 'logged-out'
};

const ValueLimits = {
  Email_MaxLength: 250,
  FileName_MaxLength: 200,
  FileName_MinLength: 2,
  Invoice_DueDate_Timespan: 30,
  Notes_MaxLength: 2_000,
  ReviewResponse_Title_MaxLength: 200,
  Role_MinLength: 3,
  Role_MaxLength: 25,
  Review_Title_MaxLength: 50,
  TheHour_Price_MinValue: 5,
  TheHour_Price_MaxValue: 500,
  TheHour_Price_Interval: 5,
  TheHour_Price_Default: 150,
  TheOngoing_TotalCapacity_Max_Value: 100,
  TheOngoing_Price_MinValue: 25,
  TheOngoing_Price_MaxValue: 1_000,
  TheOngoing_Price_Interval: 25,
  TheOngoing_Price_Default: 100,
  ThePlan_TheOngoing_ExtraInformation_MaxLength: 2_000,
  ThePlan_Price_MinValue: 100,
  ThePlan_Price_MaxValue: 10_000,
  ThePlan_Price_Interval: 100,
  ThePlan_Price_Default: 2500,
  UploadedFileSizeLimit: 500 * 1024 * 1024, // 500 MB
  UploadedFileSizeLimitDisplayValue: 500,
  Url: 2050,
  User_Bio_Part_MaxLength: 60,
  User_Bio_Long_MaxLength: 1_000,
  User_Bio_Personal_MaxLength: 500,
  User_FullName_MaxLength: 100,
  User_Name_MaxLength: 50,
  User_Name_MinLength: 2,
  User_Password_MaxLength: 50,
  User_Password_MinLength: 8,
  User_RightCapitalField_MaxLength: 500,
  User_Slug_MaxLength: 50,
  User_Slug_MinLength: 3
};

const IntakeResponseFormTypes = {
  CustomerIntakeForm: 'CustomerIntakeForm',
  ThePlanSignup: 'ThePlanSignup',
  TheOngoingSignup: 'TheOngoingSignup'
};

const Products = {
  TheHour: 'TheHour',
  ThePlan: 'ThePlan',
  TheOngoing: 'TheOngoing'
};

const ProductNames = {
  TheHour: 'The Hour',
  ThePlan: 'The Plan',
  TheOngoing: 'The Ongoing'
};

const ThePlanSignupStatus = {
  SendInitialFollowUp: 'SendInitialFollowUp',
  FollowUpAtLaterDate: 'FollowUpAtLaterDate',
  ContactAdvisor: 'ContactAdvisor',
  WaitUntilStartDate: 'WaitUntilStartDate',
  SendWelcomeEmail: 'SendWelcomeEmail',
  WaitingForAdvisor: 'WaitingForAdvisor',
  WaitingForClient: 'WaitingForClient',
  WelcomeEmailSent: 'WelcomeEmailSent',
  Cancelled: 'Cancelled',
  ContactClient: 'ContactClient'
};

const StripeInvoiceStatuses = {
  Draft: 'draft',
  Open: 'open',
  Paid: 'paid',
  Uncollectible: 'uncollectible',
  Void: 'void'
};

const TypeformConstants = {
  ThePlan_Signup: 'A2nL2Gal',
  TheOngoing_Signup: 'dRjvACMn'
};

const ApplicationRoutes = {
  About: 'about',
  Advisor: 'advisor',
  Advisors: 'advisors',
  Affiliates: 'affiliates',
  Apply: 'apply',
  Booked: 'booked',
  Contact: 'contact',
  Error: 'error',
  FlatFeeFinancialPlanners: 'flat-fee-financial-planners',
  HourlyFinancialAdvisors: 'hourly-financial-advisors',
  IntakeForm: `${AppSettings.TypeFormBaseUrl}/to/QdrDHmPg`,
  LeaveAReview: 'leaveareview',
  NonUS: 'non-us',
  MoneyTools: 'moneytools',
  NotFound: 'not-found',
  Privacy: 'privacy',
  Recruit: 'recruit',
  Register: 'register',
  Register_Affiliate: 'register?affiliate=true',
  Root: '/',
  Purchase_TheOngoing: 'purchase/the-ongoing',
  Purchase_TheOngoing_SuccessCallback: 'purchase/the-ongoing/success',
  Services: 'services',
  Terms: 'terms',
  TheOngoing_Signup: `${AppSettings.TypeFormBaseUrl}/to/dRjvACMn`,
  TheOngoing_Terms: 'the-ongoing-terms',
  ThePlan: 'the-plan',
  ThePlan_Signup: `${AppSettings.TypeFormBaseUrl}/theplansignup`,
  ThePlan_Terms: 'theplan-terms',
  AdminRoutes: {
    Root: adminRoot,
    AdvisorAttributes: 'advisorattributes',
    AdvisorAttributes_Full: `${adminRoot}/advisorattributes`,
    AdvisorPayments: 'advisorpayments',
    AdvisorPayments_Full: `${adminRoot}/advisorpayments`,
    AffiliatePayments: 'affiliatepayments',
    AffiliatePayments_Full: `${adminRoot}/affiliatepayments`,
    Documents: 'documents',
    Documents_Full: `${adminRoot}/documents`,
    Events: 'events',
    Events_Full: `${adminRoot}/events`,
    IntakeResponse: 'intake-responses',
    IntakeResponse_Full: `${adminRoot}/intake-responses`,
    IntakeResponse_Edit: `intake-response/edit`,
    IntakeResponse_Edit_Full: `${adminRoot}/intake-response/edit`,
    Recordings: 'recordings',
    Recordings_Full: `${adminRoot}/recordings`,
    Reports: 'reports',
    Reports_Full: `${adminRoot}/reports`,
    FeatureFlags: 'feature-flags',
    FeatureFlags_Full: `${adminRoot}/feature-flags`,
    TheOngoing: 'the-ongoing',
    TheOngoing_Full: `${adminRoot}/the-ongoing`,
    TheOngoing_Edit: 'the-ongoing/edit',
    TheOngoing_Edit_Full: `${adminRoot}/the-ongoing/edit`,
    TheOngoing_Signup_Edit: 'the-ongoing-signup/edit',
    TheOngoing_Signup_Edit_Full: `${adminRoot}/the-ongoing-signup/edit`,
    ThePlan: 'the-plan',
    ThePlan_Full: `${adminRoot}/the-plan`,
    ThePlan_Edit: 'the-plan/edit',
    ThePlan_Edit_Full: `${adminRoot}/the-plan/edit`,
    ThePlan_Signup_Edit: 'the-plan-signup/edit',
    ThePlan_Signup_Edit_Full: `${adminRoot}/the-plan-signup/edit`,
    Reviews: 'reviews',
    Reviews_Full: `${adminRoot}/reviews`,
    RolesRoutes: {
      Root: 'roles',
      Root_Full: `${adminRoot}/roles`,
      Create: 'create',
      Create_Full: `${adminRoot}/roles/create`
    },
    Search: 'search',
    Search_Full: `${adminRoot}/search`,
    Tools: 'tools',
    Tools_Full: `${adminRoot}/tools`,
    UploadedFiles: 'uploaded-files',
    UploadedFiles_Full: `${adminRoot}/uploaded-files`,
    UserAgreements: 'useragreements',
    UserAgreements_Full: `${adminRoot}/useragreements`,
    Users_Full: `${adminRoot}/users`,
    Users: 'users'
  },
  AdvisorAccountRoutes: {
    Root: dashboardRoot,
    Client: 'client',
    Client_Full: `${dashboardRoot}/client`,
    Compliance: `compliance`,
    Compliance_Full: `${dashboardRoot}/compliance`,
    Payments: 'payments',
    Payments_Full: `${dashboardRoot}/payments`,
    Profile: 'profile',
    Profile_Full: `${dashboardRoot}/profile`,
    AccountProfile: 'account-profile',
    AccountProfile_Full: `${dashboardRoot}/account-profile`,
    Reviews: 'reviews',
    Reviews_Full: `${dashboardRoot}/reviews`
  },
  AuthenticationRoutes: {
    Root: authenticationRoot,
    ApiAuthorizationClientConfigurationUrl: `_configuration/${AppSettings.ApplicationName}`,
    IdentityRegisterPath: 'Identity/Account/Register',
    IdentityManagePath: 'Identity/Account/Manage',
    Login: `${authenticationRoot}/login`,
    LoginDefaultRedirectPath: '/',
    LoginFailed: `${authenticationRoot}/${UserLoginActions.LoginFailed}`,
    LoginCallback: `${authenticationRoot}/${UserLoginActions.LoginCallback}`,
    Logout: `${authenticationRoot}/logout`,
    LoggedOut: `${authenticationRoot}/${UserLogoutActions.LoggedOut}`,
    LogOutCallback: `${authenticationRoot}/${UserLogoutActions.LogoutCallback}`,
    Profile: `${authenticationRoot}/${UserLoginActions.Profile}`
  },
  ClientAccountRoutes: {
    Root: accountRoot,
    Advisors: 'advisors',
    Manage_Full: 'Identity/Account/Manage',
    BillingHistory: 'billing',
    BillingHistory_Full: `${accountRoot}/billing`,
    Reviews: 'reviews',
    Reviews_Full: `${accountRoot}/reviews`,
    PastMeetings: 'past-meetings',
    PastMeetings_Full: `${accountRoot}/past-meetings`,
    Profile: 'profile',
    Profile_Full: `${accountRoot}/profile`,
    SecureFileVault: 'secure-file-vault',
    SecureFileVault_Full: `${accountRoot}/secure-file-vault`,
    Share: 'share',
    Share_Full: `${accountRoot}/share`
  },
  SeoLandingPagesRoutes: {
    Root: servicesRoot,
    FeeOnlyFiduciaries: 'fee-only-fiduciaries',
    FeeOnlyFiduciaries_Full: `${servicesRoot}/fee-only-fiduciaries`,
    FiduciaryCFPS: 'fiduciary-cfps',
    FiduciaryCFPS_Full: `${servicesRoot}/fiduciary-cfps`,
    FlatRateFinancialPlanners: 'flat-rate-financial-planners',
    FlatRateFinancialPlanners_Full: `${servicesRoot}/flat-rate-financial-planners`,
    IndependentFinancialAdvisors: 'independent-financial-advisors',
    IndependentFinancialAdvisors_Full: `${servicesRoot}/independent-financial-advisors`
  },
  SharingPageRoutes: {
    Root: shareRoot
  }
};

const UserRoles = {
  Admin: 'Admin',
  Advisor: 'Advisor',
  Affiliate: 'Affiliate',
  Consumer: 'Consumer'
};

const CommonApiBadRequestErrors = {
  NotLoggedIn: 'notLoggedIn',
  DeletedEntity: 'deletedEntity',
  NoMatchingAdvisor: 'noMatchingAdvisor',
  RefundFailed: 'refundFailed'
};

const CommonErrorMessages = {
  General: `We're sorry, but an error occurred.`,
  NotLoggedIn: 'You must be logged in to continue.',
  DeletedEntity: 'The requested record has been deleted.',
  NoMatchingAdvisor: 'The requested advisor was not found.',
  RefundFailed: 'The refund to the customer failed.'
};

const HTTPStatuses = {
  Ok: 200,
  NoContent: 204,
  BadRequest: 400,
  NotFound: 404
};

const CommonQueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

const AdminEventStatuses = {
  Active: 'Active',
  ActiveNoNotesRequired: 'ActiveNoNotesRequired',
  Canceled: 'Canceled',
  Refunded: 'Refunded',
  NoShow: 'NoShow',
  ActiveEventStatuses: ['']
};

AdminEventStatuses.ActiveEventStatuses = [AdminEventStatuses.Active, AdminEventStatuses.ActiveNoNotesRequired];

const MeetingStatus = {
  Scheduled: 'Scheduled',
  Cancelled: 'Cancelled',
  Completed: 'Completed'
};

enum SortOptions {
  Newest = 1,
  Oldest = 2,
  Highest = 3,
  Lowest = 4
}

export {
  AdminEventStatuses,
  ApplicationRoutes,
  AppSettings,
  AttributeCategories,
  AttributeCategoriesText,
  CommonApiBadRequestErrors,
  CommonErrorMessages,
  CommonQueryParameterNames,
  FeatureFlags,
  HTTPStatuses,
  IntakeResponseFormTypes,
  LocalStorageKeys,
  MeetingStatus,
  ProductNames,
  Products,
  RecordingStatus,
  SortOptions,
  StripeInvoiceStatuses,
  ThePlanSignupStatus,
  TypeformConstants,
  UserLoginActions,
  UserLogoutActions,
  UserRoles,
  ValueLimits
};
